import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import {
  FontColor,
  FontEmphasis,
  FontWeight,
} from '@prisjakt/ui/text/variants';
import type { ContainerType } from '@prisjakt/ui/lib';
import { Currency, formatCurrency } from 'src/components/currency';

import * as S from './styles';

type Props = {
  className?: string;
  container?: ContainerType;
  value: number | string | React.ReactNode;
  emphasis?: FontEmphasis;
  fontColor?: FontColor;
  weight?: FontWeight;
  isSecondaryPrice?: boolean;
  memberPrice?: boolean;
};

export const PriceLabel: React.FC<Props> = ({
  className,
  container = 'span',
  emphasis = FontEmphasis.HIGH,
  fontColor = FontColor.DARK,
  value,
  weight = FontWeight.HEAVIER,
  isSecondaryPrice = false,
  memberPrice = false,
}) => {
  const context = useContext(AppContext);

  const formatPrice = (num: number) =>
    formatCurrency(num, context.market?.code, false, '', false);

  const renderFormattedPrice = () => {
    if (typeof value !== 'number') return value;
    if (isSecondaryPrice && memberPrice) return `(${formatPrice(value)})`;
    if (isSecondaryPrice) return `${formatPrice(value)}`;
    return <Currency price={value} />;
  };

  return (
    <S.PriceLabel
      className={className}
      color={fontColor}
      container={container}
      emphasis={emphasis}
      weight={weight}
    >
      {renderFormattedPrice()}
    </S.PriceLabel>
  );
};
